import angular from 'angular';
import template from './recruiterSingupView.html';

export class RecruiterSingupComponent {
    /* @ngInject */
    constructor(AuthService, $sessionStorage, RouteService) {
        const recruiterSingupCtrl = this;
        recruiterSingupCtrl.init = function () {
            this.isRegistrationWithLinkedInAvailable = RouteService.getSystemDefaults('isRegistrationWithLinkedInAvailable');
        };

        recruiterSingupCtrl.loginWith = function (loginWithApp, userType) {
            $sessionStorage.userType = userType;
            $sessionStorage.singup = 'recruiter';
            AuthService.loginWith(loginWithApp);
        };

        recruiterSingupCtrl.init();
    }
}

export const RecruiterSingupComponentConfiguration = {
    template,
    controller: RecruiterSingupComponent,
    controllerAs: 'recruiterSingupCtrl',
};

angular
    .module('TALENYA-FE')
    .component('recruiterSingupComponent', RecruiterSingupComponentConfiguration);
